<template>
    <div class="container-fluid">
        <div class="classification--stars">
            <img src="/images/offes-news-img/stars-orange.png" />
        </div>
    </div>
</template>
<script>
export default {
    name:'ClassificationStars' 
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// classification-stars.vue?08d7e0d2